import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../../firebase";

// SmsPage/BirthdaysPage'in beklediği (eski) üye şekli — Firestore members'tan adapte edilir.
// id artık STRING (telefon/döküman ID); seçim mantığı Set<string> kullanır.
export interface AdminMember {
  id: string;
  adSoyad: string;
  telefon: string;
  cinsiyet: string;
  status: string;
  birthDate: string;
  dogumAy: number | null;
  dogumGun: number | null;
}

// birthDate ISO "YYYY-MM-DD" → { ay, gun }. Boş/bozuk → null (çökme yok).
function parseBirth(birthDate: string): { ay: number | null; gun: number | null } {
  if (!birthDate || typeof birthDate !== "string") return { ay: null, gun: null };
  const m = birthDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return { ay: null, gun: null };
  const ay = parseInt(m[2], 10);
  const gun = parseInt(m[3], 10);
  if (Number.isNaN(ay) || Number.isNaN(gun) || ay < 1 || ay > 12 || gun < 1 || gun > 31) {
    return { ay: null, gun: null };
  }
  return { ay, gun };
}

export function useMembers() {
  const [members, setMembers] = useState<AdminMember[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(false);
      try {
        const snap = await getDocs(query(collection(db, "members"), orderBy("displayName", "asc")));
        const list: AdminMember[] = snap.docs.map((d) => {
          const data = d.data() as any;
          const { ay, gun } = parseBirth(data.birthDate ?? "");
          return {
            id: d.id, // telefon (string)
            adSoyad: data.displayName ?? "",
            telefon: data.phone ?? d.id,
            cinsiyet: data.gender ?? "",
            status: data.status ?? "",
            birthDate: data.birthDate ?? "",
            dogumAy: ay,
            dogumGun: gun,
          };
        });
        if (!cancelled) setMembers(list);
      } catch (e) {
        console.error("Üyeler okunamadı:", e);
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { members, loading, error };
}
